import overview1 from "../../assets/img/tools/b1-1.png";
import overview2 from "../../assets/img/tools/b1-2.png";
import overview3 from "../../assets/img/tools/b1-3.png";
import overview4 from "../../assets/img/tools/b1-4.png";
import overview5 from "../../assets/img/tools/b1-5.png";
import overview6 from "../../assets/img/tools/b1-6.png";
import overview7 from "../../assets/img/tools/b1-7.png";
import overview8 from "../../assets/img/tools/b1-8.png";

import b1 from "../../assets/img/tools/b2-1.png";
import b2 from "../../assets/img/tools/b2-2.png";
import b3 from "../../assets/img/tools/b2-3.png";
import b4 from "../../assets/img/tools/b2-4.png";
import b5 from "../../assets/img/tools/b2-5.png";
import b6 from "../../assets/img/tools/b2-6.png";
import b7 from "../../assets/img/tools/b2-7.png";

import last1 from "../../assets/img/tools/p3-1.png";
import last2 from "../../assets/img/tools/p3-2.png";
import last3 from "../../assets/img/tools/p3-3.png";
import last4 from "../../assets/img/tools/p3-4.png";
import last5 from "../../assets/img/tools/p3-5.png";
import last6 from "../../assets/img/tools/p3-6.png";
import last7 from "../../assets/img/tools/p3-7.png";
import last8 from "../../assets/img/tools/p3-8.png";
import last9 from "../../assets/img/tools/p3-9.png";
import last10 from "../../assets/img/tools/p3-10.png";
import last11 from "../../assets/img/tools/p3-11.png";
import last12 from "../../assets/img/tools/p3-12.png";
import last13 from "../../assets/img/tools/p3-13.png";
import last14 from "../../assets/img/tools/p3-14.png";
import last15 from "../../assets/img/tools/p3-15.png";
import last16 from "../../assets/img/tools/p3-16.png";
import last17 from "../../assets/img/tools/p3-17.png";
import last18 from "../../assets/img/tools/p3-18.png";
import last19 from "../../assets/img/tools/p3-19.png";
import last20 from "../../assets/img/tools/p3-20.png";
import last21 from "../../assets/img/tools/p3-21.png";
import last22 from "../../assets/img/tools/p3-22.png";

const data = [
  {
    id: 1,
    title: "Tool	Solutions",
    unit: "",
    url: last1,
  },
  {
    id: 2,
    title: "Mobile Maintenance imperial",
    unit: "21.8 kg, 48.1 lbs., W/H/D 670/510/262 mm Number of tools: 142",
    url: last2,
  },
  {
    id: 3,
    title: "Mobile Maintenance imperial",
    unit: "14.04 kg, 30.95 lbs., W/H/D 546/347/247 mm Number of tools: 109",
    url: last3,
  },
  {
    id: 4,
    title: "Tool kit Avionic imperial",
    unit: "24.37 kg, 53.72 lbs., W/H/D 670/510/372 mm Number of tools: 128",
    url: last4,
  },
  {
    id: 5,
    title: "Kit, Avionic Meas. Supply NG",
    unit: "6.1 kg, 13.45 lbs., W/H/D 490/430/190 mm Number of tools: 68",
    url: last5,
  },
  {
    id: 6,
    title: "Kit, Avionic Meas. Supply",
    unit: "5.0 kg, 11.02 lbs., W/H/D 410/340/205 mm Number of tools: 29",
    url: last6,
  },
  {
    id: 7,
    title: "Tool kit Cabin imperial",
    unit: "23.73 kg, 52.31 lbs., W/H/D 670/510/372 mm Number of tools: 116",
    url: last7,
  },
  {
    id: 8,
    title: "Maintenance kit Mechanic imperial",
    unit: "28.13 kg, 62.02 lbs., W/H/D 670/510/372 mm Number of tools: 174",
    url: last8,
  },
  {
    id: 9,
    title: "Cabin Kit Avionic imperial",
    unit: "6.75 kg, 14.87 lbs., W/H/D 410/340/205 mm Number of tools: 60",
    url: last9,
  },
  {
    id: 10,
    title: "Cabin Kit Mechanic imperial",
    unit: "9.1 kg, 20.0 lbs., W/H/D 410/340/205 mm Number of tools: 78",
    url: last10,
  },
  {
    id: 11,
    title: "Cabin Kit Systems Mechanic",
    unit: "9.40 kg, 20.72 lbs., W/H/D 410/340/205 mm Number of tools: 77",
    url: last11,
  },
  {
    id: 12,
    title: "Cabin Kit Mechanic imperial",
    unit: "8.61 kg, 18.98 lbs., W/H/D 410/340/205 mm Number of tools: 79",
    url: last12,
  },
  {
    id: 13,
    title: "Tool Trolleys",
    unit: "",
    url: last13,
  },
  {
    id: 14,
    title: "Line Maintenance Set imperial",
    unit: "11.50 kg, 25.30 lbs., W/H/D 510/415/230 mm Number of tools: 122/Tool trolley not included",
    url: last14,
  },
  {
    id: 15,
    title: "Special Tool Trolley",
    unit: "WT/LR & 771190324a WT/LS 15.0 kg, 33.07 lbs. , W/H/D 585/457/381 mm",
    url: last15,
  },
  {
    id: 16,
    title: "Line Maintenance Set imperial",
    unit: "28.2 kg, 62.17 lbs. Number of tools: 122",
    url: last16,
  },
  {
    id: 17,
    title: "AOG Kit imperial",
    unit: "28.4 kg, 62.61 lbs. Number of tools: 154",
    url: last17,
  },
  {
    id: 18,
    title: "Mobile Aviation Mechanics",
    unit: "16.0 kg, 35.27 lbs., W/H/D 445/345/190 mm Number of tools: 159",
    url: last18,
  },
  {
    id: 19,
    title: "Workshop trolley imperial",
    unit: "95.0 kg, 209.44 lbs., W/H/D 677/501/950 mm Number of tools: 203",
    url: last19,
  },
  {
    id: 20,
    title: "Workshop trolley Avionic",
    unit: "51.0 kg, 112.43 lbs., W/H/D 677/501/420 mm Number of tools: 27",
    url: last20,
  },
  {
    id: 21,
    title: "Crowfoot Toolbox",
    unit: "11.0 kg, 24.25 lbs., W/H/D 546/347/197 mm Number of tools: 42",
    url: last21,
  },
  {
    id: 22,
    title: "Kit, Dent Inspection",
    unit: "1.3 kg, 2.87 lbs., W/H/D 216/180/102 mm Number of tools: 5",
    url: last22,
  },
];
const ToolSolutions = () => {
  return (
    <>
      <section className="serviceSection sectionPD">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="fisherman-content">
                <h3>Mechanical Kit- B1 Trade </h3>
                <strong>PN : GGASB1T</strong>
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="toolFigure">
                <img src={overview1} alt="Overview" className="img-fluid" />
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="toolFigure">
                <img src={overview2} alt="Overview" className="img-fluid" />
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="toolFigure">
                <img src={overview3} alt="Overview" className="img-fluid" />
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="toolFigure">
                <img src={overview4} alt="Overview" className="img-fluid" />
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="toolFigure">
                <img src={overview5} alt="Overview" className="img-fluid" />
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="toolFigure">
                <img src={overview6} alt="Overview" className="img-fluid" />
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="toolFigure">
                <img src={overview7} alt="Overview" className="img-fluid" />
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="toolFigure">
                <img src={overview8} alt="Overview" className="img-fluid" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="serviceSection sectionPD bgGray">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="fisherman-content">
                <h3>Avionics Kit- B2 Trade </h3>
                <strong>PN : GGASB2T</strong>
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="toolFigure">
                <img src={b1} alt="Overview" className="img-fluid" />
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="toolFigure">
                <img src={b2} alt="Overview" className="img-fluid" />
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="toolFigure">
                <img src={b3} alt="Overview" className="img-fluid" />
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="toolFigure">
                <img src={b4} alt="Overview" className="img-fluid" />
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="toolFigure">
                <img src={b5} alt="Overview" className="img-fluid" />
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="toolFigure">
                <img src={b6} alt="Overview" className="img-fluid" />
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="toolFigure">
                <img src={b7} alt="Overview" className="img-fluid" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="serviceSection sectionPD">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="fisherman-content">
                <h3>Tool Solutions </h3>
              </div>
            </div>
            {data.map((item) => {
              return (
                <div className="col-lg-6" key={item.id}>
                  <div className="toolFigureFooter">
                    <img src={item.url} alt={item.title} title={item.title} className="img-fluid" />
                    <div className="text">
                      <h4>{item.title}</h4>
                      <p>{item.unit}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
};

export default ToolSolutions;
